export const SET_PAYMENT_STATUS = 'SET_PAYMENT_STATUS';
export const SET_PAYMENT_KEY = 'SET_PAYMENT_KEY';
